export * from './weak-set/is-weak-set.js';
